import { render } from "./Animation.vue?vue&type=template&id=7b046c8f"
import script from "./Animation.vue?vue&type=script&lang=js"
export * from "./Animation.vue?vue&type=script&lang=js"
script.render = render

export default script